export enum Pages {
  Quotation = 'quotation',
  Plan = 'plan',
  Questionnaire = 'questionnaire',
  Application = 'application',
  Review = 'review',
  Payment = 'payment',
}
